export default (listeners = [], ...args) => {
  for (let i = -1; ++i < listeners.length; ) {
    listeners[i](...args)
  }
}
